<auth-page-layout title="Patient Portal"
                  logoUrl="" cardTitle="We're Sorry"
                  illustration="">
  <p>This patient portal is down for maintenance.</p>
  <p>Please try again later.</p>
</auth-page-layout>
